module.exports = __webpack_public_path__ + "img/188_05.0616ff01.png";